import { render } from "./proche_sorov_zakupshik.vue?vue&type=template&id=1ff717ac&scoped=true"
import script from "./proche_sorov_zakupshik.vue?vue&type=script&lang=js"
export * from "./proche_sorov_zakupshik.vue?vue&type=script&lang=js"

import "./proche_sorov_zakupshik.vue?vue&type=style&index=0&id=1ff717ac&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff717ac"]])

export default __exports__